import { createFileRoute } from '@tanstack/react-router'

import { NnppLayout } from '@/src/pages/nnpp/NnppLayout'

export const Route = createFileRoute('/nnpp')({
  component: NnppLayout,
  staticData: {
    title: 'NNPP',
    layout: { enableScrolling: true, showSearchBar: false },
  },
})
